import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthTokenService } from '../services/auth-token.service';
import { AuthService } from '../services/auth.service';
import { getAuthErrorReason } from '../auth-error/auth-error.component';

// Starts the route-specific Cognito flow and prevents cross-role route access.
export const authTokenGuard: CanActivateFn = (_route, state) => {
  console.log('[REM flow] authTokenGuard', { url: state.url });
  const authToken = inject(AuthTokenService);
  const auth = inject(AuthService);
  //const legacyAuth = inject(AuthService);
  const router = inject(Router);
  const requestedRole = authToken.getAuthFlowForReturnUrl(state.url);

  // if (authToken.isAuthenticated() || (environment.legacyAuthenticationEnabled && legacyAuth.isAuthenticated())) {
  //   console.log(': token already available');
  //   return true;
  // }

  const redirectForRole = (role: 'dealer' | 'nsc') =>
    router.createUrlTree([role === 'nsc' ? '/nsc/dashboard' : '/dealer/dashboard']);

  const authorizeCurrentRole = () => {
    const currentRole = auth.getCurrentContextSync()?.role;
    if (!currentRole) {
      return router.createUrlTree(['/auth/error']);
    }
    return currentRole === requestedRole ? true : redirectForRole(currentRole);
  };

  if (authToken.isAuthenticatedFor(state.url)) {
    return auth.getCurrentContextSync() ? authorizeCurrentRole() : auth.getCurrentUser().pipe(
      map(() => authorizeCurrentRole()),
      catchError(error => {
        console.error('[REM flow] authTokenGuard: role resolution failed', error);
        const reason = getAuthErrorReason(error);
        return of(router.createUrlTree(['/auth/error'], { queryParams: { reason } }));
      })
    );
  }

  console.log('[REM flow] authTokenGuard: starting route-specific Cognito login', { requestedRole });
  return authToken.startLogin(state.url)
    .then(() => false)
    .catch((error) => {
      console.error('[REM flow] authTokenGuard: Cognito redirect failed', error);
      return router.createUrlTree(['/auth/error']);
    });
};